import { generateTestId } from "@client-shared";

export const setServiceTileTestId = (identifier: string): string =>
  generateTestId("ServiceTile", identifier);
